import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const fetchPlans = async () => {
  return axiosPrivate.get('/reach/get_sms_plan/');
};

export const fetchCurrentPlan = async () => {
  return axiosPrivate.get('/reach/get_smsbundle_subscription/');
};

export const subscribeToPlan = async (payload: {
  plan_id: number;
  platform: string;
}) => {
  return axiosPrivate.post('/reach/subscribe_plan/', payload);
};
